import { Injectable } from '@angular/core';
import { ApiAuthService } from './api-auth.service';
import { ToTypeOrm } from '../models/_to-type-orm.schema';

@Injectable({
  providedIn: 'root'
})
export class TransactionsService extends ApiAuthService {

  private readonly url = `${this.baseUrl}/transactions`;

  async getCreditAmount(expertId: number): Promise<{ amount: number }>{
    return this.request(() => this.http.get(`${this.url}/credit/${expertId}`).toPromise() );
  }

  async getDebitAmount(expertId: number): Promise<{ amount: number }>{
    return this.request(() => this.http.get(`${this.url}/debit/${expertId}`).toPromise() );
  }

  async getTransactions(expertId: number, page?: number, limit?: number, order?: {}, filter: any = {}): Promise<any> {
      return this.getAll(expertId, page, limit, order, filter);
  }

  async getAll(expertId: number, page?: number, limit?: number, order?: {}, filter?: { [key: string]: ToTypeOrm }): Promise<any> {
    let params = {};
    if (page) params['page'] = page;
    if (limit) params['limit'] = limit;
    if (order) params['order'] = JSON.stringify(order);
    if (filter) params['filter'] = JSON.stringify(filter);
    return this.request(() => 
      this.http.get<any>(`${this.url}/all/${expertId}`, { params: params }).toPromise()
    );
  }
}
